var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargingStationMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-41 -41 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 41,
    fill: "rgba(255, 255, 255, 0.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M -2 -32 A 30 32 0 0 0 -2 32",
    stroke: "#328734",
    strokeWidth: 18,
    transform: "rotate(180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M -2 -32 A 30 32 0 0 0 -2 32",
    stroke: "#D50042",
    strokeWidth: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingStationMarker);
export default __webpack_public_path__ + "static/media/chargingStationMarker.47682048a21198fd3cee44c462a8c979.svg";
export { ForwardRef as ReactComponent };